export const RECEIVE_SERVICE = "RECEIVE_SERVICE";
export const RECEIVE_STOPS = "RECEIVE_STOPS";
export const RECEIVE_POLYLINE = "RECEIVE_POLYLINE";
export const RESET_VIEW = "RESET_VIEW";
